export default __webpack_public_path__ + "static/media/coursemanagerimg.fa500bc5.png";